// src/components/About.js

import React from "react";

export default function About() {
  return (
    <section id="about">
      <div className="container mx-auto flex px-10 py-20 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h4 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-white">
            HANANE ELLIOUA.
            <br className="hidden lg:inline-block" />
            <br className="hidden lg:inline-block" />
            Actuellement professeur chercheur à l'Ecole Nationale  des Sciences Appliquées (ENSA) de Berrechid - Université Hassan I Settat
          </h4>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            src="./prof.jpeg"
          />
        </div>
      </div>
    </section>
  );
}


// WEBPACK FOOTER //
// ./src/Components/about.js